import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/globalStyles.css';
import './styles/globals.css';
import App from './App';
import posthog from 'posthog-js';

posthog.init('phc_6sIpm7nSjUl14Wx7fxDTTUBnXVhLDF4yIOg0RwSdHjk', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
});

const EXTENSION_CHANNEL_CLOSED_ERRORS = [
  'A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received',
  'The page keeping the extension port is moved into back/forward cache, so the message channel is closed.',
];

// Suppress known benign extension port-close promise rejections (MetaMask/other extensions),
// while preserving all application-originated errors.
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message =
    typeof reason === 'string'
      ? reason
      : reason instanceof Error
        ? reason.message
        : '';

  if (EXTENSION_CHANNEL_CLOSED_ERRORS.some((text) => message.includes(text))) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);